var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;


























jade_mixins["readonly-block"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div ng-if=\"vm.isReadonly() || !vm.globalBearbeiten\" ng-show=\"!vm.editMode\" ng-class=\"{'clearfix-hover' : vm.hoverPosition}\" class=\"clearfix box_hover\">");
block && block();
buf.push("</div><div ng-if=\"!vm.isReadonly() &amp;&amp; vm.globalBearbeiten\" ng-show=\"!vm.editMode\" ng-click=\"!vm.isReadonly() &amp;&amp; vm.globalBearbeiten ? vm.toggleEditMode() : null\" data-toggle=\"{{!vm.isReadonly() &amp;&amp; vm.globalBearbeiten ? 'edit' : ''}}\" ng-class=\"{ 'editable' : !vm.isReadonly() &amp;&amp; vm.globalBearbeiten }\" tabindex=\"-1\" class=\"clearfix box_hover\">");
block && block();
buf.push("</div>");
};















jade_mixins["form-element"] = jade_interp = function(idx, label, helpText, fieldName, helpTextChange){
var block = (this && this.block), attributes = (this && this.attributes) || {};
jade_mixins["client-form-error-list-els"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
};
buf.push("<div" + (jade.cls([attributes.class], [false])) + "><!--label.font-weight-bold(ng-class=\"{'error': vm.errors['#{fieldName}'] || vm.form['#{fieldName}'].$invalid , 'warning': vm.isMissing('#{fieldName}')}\")--><label" + (jade.attr("ng-class", "{'has-error': vm.errors['" + (fieldName) + "'] || vm.form['" + (fieldName) + "'].$invalid , 'warning': vm.isMissing('" + (fieldName) + "')}", true, true)) + " class=\"font-weight-bold\"><span class=\"titel\">" + (jade.escape((jade_interp = idx) == null ? '' : jade_interp)) + " " + (jade.escape((jade_interp = label) == null ? '' : jade_interp)) + "<span" + (jade.attr("ng-show", "vm.isFieldRequired('" + (fieldName) + "');", true, true)) + ">*</span><span class=\"alert-danger\"></span></span><br><span class=\"hint\">" + (jade.escape(null == (jade_interp = helpText) ? "" : jade_interp)));
if ( helpTextChange)
{
buf.push("<span class=\"hint\">&nbsp; {{" + (jade.escape((jade_interp = helpTextChange) == null ? '' : jade_interp)) + " < 0 ? -1 * " + (jade.escape((jade_interp = helpTextChange) == null ? '' : jade_interp)) + " + \" zu lang\" : \"noch \" + " + (jade.escape((jade_interp = helpTextChange) == null ? '' : jade_interp)) + " + \" Zeichen\"}}</span>");
}
buf.push("</span><div>");
block && block();
buf.push("<div" + (jade.attr("ng-if", "vm.form['" + (fieldName) + "'].$invalid || vm.errors['" + (fieldName) + "']", true, true)) + " class=\"help-block\"><ul class=\"errorlist\"><li" + (jade.attr("ng-repeat", "err in vm.errors['" + (fieldName) + "']", true, true)) + ">{{ err }}</li>");
jade_mixins["client-form-error-list-els"]();
buf.push("</ul></div></div></label></div>");
};






jade_mixins["form-element"] = jade_interp = function(label, fieldName, errorsMap, prefix){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div" + (jade.attr("ng-class", "{'has-error': " + (errorsMap) + "['" + (fieldName) + "']}", true, true)) + (jade.cls(['form-group','row',attributes.class], [null,null,false])) + "><label" + (jade.attr("ng-attr-for", "{{" + (prefix) + "}}_" + (fieldName) + "", true, true)) + " class=\"col-form-label col-sm-3 text-right font-weight-bold required\"><span" + (jade.attr("ng-class", "{'required':vm.isRequired('" + (fieldName) + "')}", true, true)) + " class=\"titel\">" + (jade.escape((jade_interp = label) == null ? '' : jade_interp)) + "<span class=\"alert-danger\"></span></span></label><div class=\"col-sm-9 col-xl-6\">");
block && block();
buf.push("<label" + (jade.attr("ng-attr-for", "{{" + (prefix) + "}}_" + (fieldName) + "", true, true)) + " class=\"help-block\"><ul" + (jade.attr("ng-if", "" + (errorsMap) + "['" + (fieldName) + "']", true, true)) + " class=\"errorlist\"><li" + (jade.attr("ng-repeat", "err in " + (errorsMap) + "['" + (fieldName) + "']", true, true)) + ">{{ err }}</li></ul></label></div></div>");
};


























jade_mixins["vorschau-daten"] = jade_interp = function(vorschau){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div" + (jade.attr("ng-repeat", "(key, val) in " + (vorschau) + "", true, true)) + "><span ng-if=\"val\">{{key}}: {{ val }}</span></div>");
};






jade_mixins["position-form"] = jade_interp = function(showFlag, toggleFunc, saveFunc, mouseenterFunc, mouseleaveFunc, hoverEdit, headerText, posModel, errorsMap, prefix){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<form" + (jade.attr("ng-submit", "" + (saveFunc) + "", true, true)) + " class=\"form-horizontal\"><div" + (jade.attr("ng-if", "" + (showFlag) + "", true, true)) + (jade.attr("ng-class", "{ 'hover-edit' : " + (hoverEdit) + "}", true, true)) + " class=\"position-form\"><header><h3>" + (jade.escape((jade_interp = headerText) == null ? '' : jade_interp)) + "</h3><div class=\"actions\"><button" + (jade.attr("ng-click", "" + (toggleFunc) + "", true, true)) + " type=\"button\"" + (jade.attr("ng-mouseenter", "" + (mouseenterFunc) + "", true, true)) + (jade.attr("ng-mouseleave", "" + (mouseleaveFunc) + "", true, true)) + " class=\"btn btn-icon\"><span><i class=\"glyphicon glyphicon-remove\"></i><span>Schließen</span></span></button></div></header><div" + (jade.attr("ng-if", "vm.isErrors(" + (errorsMap) + ")", true, true)) + " class=\"row\"><div role=\"alert\" class=\"col-lg-12 alert alert-danger alert-no-notification\"><strong>Bitte überprüfen Sie Ihre Eingaben.</strong><div" + (jade.attr("ng-repeat", "(field, errors) in " + (errorsMap) + "", true, true)) + " class=\"errorlist\"><div ng-repeat=\"err in errors\"><strong>{{vm.showErrorLabel(field)}}</strong><span ng-if=\"!vm.angular.isArray(err)\">&nbsp;{{ err }}</span><span ng-if=\"vm.angular.isArray(err)\">&nbsp;{{ err[0] }}</span></div></div></div></div><div dias-loading=\"vm.loading\" loading-msg=\"'wird gespeichert'\" class=\"row\"><div ng-if=\"vm.katalogDetails.length &gt; 0\" ng-disabled=\"vm.loading\">");
jade_mixins["form-element"].call({
block: function(){
buf.push("<select" + (jade.attr("ng-model", "" + (posModel) + ".finanzierungsartdetail", true, true)) + " name=\"finanzierungsartdetail\"" + (jade.attr("ng-change", "vm.update_bez(" + (posModel) + ")", true, true)) + " auto-focus=\"{{!!vm.katalogDetails.length}}\" aria-required=\"true\" ng-disabled=\"vm.parameter.ohne_positionen\"" + (jade.attr("ng-attr-id", "{{" + (prefix) + "}}_finanzierungsartdetail", true, true)) + " role=\"listbox\" class=\"form-control\"><option value=\"\">--- Bitte wählen Sie ---</option><option ng-repeat=\"fd in vm.katalogDetails\" value=\"{{fd.fid_id}}\">{{fd.fid_kbez}}</option></select>");
}
}, "Typ / Kategorie", "finanzierungsartdetail", errorsMap, prefix);
buf.push("</div><betragsrechner rechner=\"vm.betragsrechner\"" + (jade.attr("posmodel", "" + (posModel) + "", true, true)) + (jade.attr("errors", "" + (errorsMap) + "", true, true)) + " extras=\"vm.extras\"" + (jade.attr("prefix", "" + (prefix) + "", true, true)) + " kontext=\"vm.kontext\" extra-field-update=\"'finanzierungsartdetail'\"></betragsrechner></div><div class=\"edit-actions row\"><div class=\"col-lg-6\"><dias-requirement></dias-requirement></div><div class=\"col-lg-6 right\"><div class=\"form-actions\"><button type=\"submit\" ng-disabled=\"vm.loading\" class=\"btn btn-primary primary-action test-save\">Speichern</button><button type=\"button\" ng-disabled=\"vm.loading\"" + (jade.attr("ng-click", "" + (toggleFunc) + "", true, true)) + " class=\"btn btn-default secondary-action\">Abbrechen</button></div></div></div></div></form>");
};
jade_mixins["no-position"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"position\"><div>{{vm.idx}}</div><div>{{vm.antragKoFiArt.bez}}<button ng-click=\"vm.toggleStatusInfo()\" ng-class=\"{ 'active': vm.statusInfo }\" type=\"button\" ng-attr-title=\"Zusatzinformation bezüglich {{vm.antragKoFiArt.bez}} {{vm.statusInfo ? 'ausblenden': 'einblenden'}}\" ng-attr-aria-expanded=\"{{vm.statusInfo}}\" ng-if=\"vm.modul.regel.afr_astbez\" class=\"btn btn-icon toggle-info\"><span class=\"glyphicon glyphicon-info-sign\"></span></button><div ng-if=\"vm.get_single_position()\" class=\"small text-left\">{{vm.get_single_position().akp_bez}}</div></div><div>{{vm.getSumme() | currency}}</div><div class=\"version\">{{vm.searchInSnapshot(vm.antragKoFiArt.artPk,  vm.antragKoFiArt.diffKey, vm.antragKoFiArt.pk) | currency}}</div><div class=\"procent\"><span ng-if=\"vm.show_prozente()\">{{vm.get_prozent() | number:2 }}&nbsp;%</span></div><div></div><div><div ng-if=\"!vm.readonly\"><div><div ng-if=\"vm.get_single_position()\"><button type=\"button\" ng-click=\"vm.toggleEditPosition(vm.get_single_position())\" data-toggle=\"edit-note\" class=\"btn btn-icon\"><span class=\"glyphicon glyphicon-pencil\"></span></button><button type=\"button\" dias-confirm confirm-title=\"Finanzierung zurücksetzen?\" confirm-type=\"danger\" confirm-ok-label=\"Ja\" confirm-ok=\"vm.deletePosition(vm.get_single_position())\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-trash\"></span></button></div><div ng-if=\"!vm.get_single_position()\"><button type=\"button\" ng-show=\"!vm.addPositionMode &amp;&amp; !vm.readonly\" ng-click=\"vm.toggleAddPosition()\" class=\"btn btn-default\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp; {{:: vm.gettext(\"Finanzierung angeben\")}}</button></div></div></div></div></div><div ng-show=\"vm.modul.regel.afr_kbez || vm.modul.regel.afr_bezeichnung\" class=\"rules\"><h5 ng-bind-html=\"vm.modul.regel.afr_kbez\"></h5><div ng-bind-html=\"vm.modul.regel.afr_bezeichnung\"></div></div><div ng-show=\"vm.statusInfo\" role=\"alert\" class=\"info\"><button ng-attr-title=\"Zusatzinformation bezüglich {{vm.antragKoFiArt.bez}} {{vm.statusInfo ? 'ausblenden': 'einblenden'}}\" ng-click=\"vm.toggleStatusInfo()\" class=\"btn btn-icon btn-absolute\"><i class=\"glyphicon glyphicon-remove\"></i></button><div ng-bind-html=\"vm.modul.regel.afr_astbez\"></div></div><div ng-hide=\"vm.statusHidePositionen\" class=\"position-detail\"><div class=\"position-edit\">");
jade_mixins["position-form"]("vm.editPositionModes[vm.get_single_position().pk]",
                     "vm.toggleEditPosition(vm.get_single_position())",
                     "vm.updatePosition(vm.editPositionen[vm.get_single_position().pk])",
                     "vm.mouseenterPosition(p.pk)",
                     "vm.mouseleavePosition(p.pk)",
                     "vm.hoverEdit[p.pk]",
                     "Finanzierung bearbeiten",
                     "vm.editPositionen[vm.get_single_position().pk]",
                     "vm.updateErrors[vm.get_single_position().pk]",
                     "vm.getDeburredString(vm.antragKoFiArt.bez) + '_' + $index");
jade_mixins["position-form"]("vm.addPositionMode",
                     "vm.toggleAddPosition()",
                     "vm.createPosition()",
                     "vm.mouseenterPosition()",
                     "vm.mouseleavePosition()",
                     "vm.hoverEditNew",
                     "Finanzierung angeben",
                     "vm.newPosition",
                     "vm.createErrors",
                     "vm.getDeburredString(vm.antragKoFiArt.bez) + '_' + $index");
buf.push("</div></div>");
};






jade_mixins["readonly-block"].call({
block: function(){
buf.push("<div>");
jade_mixins["no-position"]();
buf.push("</div>");
}
});;return buf.join("");
}